import logoWhite from '../assets/paszport-dolnego-slaska-logo-white.jpg'

type Props = {
  title?: string
  subtitle?: string
}

export function BrandMark({
  title = 'Paszport Dolnego Śląska',
  subtitle = 'Edycja 2026',
}: Props) {
  return (
    <div className="flex items-center gap-3">
      <img
        src={logoWhite}
        alt="Paszport Dolnego Śląska"
        className="h-10 w-10 shrink-0 select-none rounded-lg object-contain"
        draggable={false}
        loading="lazy"
        decoding="async"
      />
      <div className="hidden min-w-0 leading-tight min-[400px]:block lg:block">
        <div className="text-sm font-extrabold tracking-tight">{title}</div>
        <div className="hidden text-xs text-ink/55 sm:block">{subtitle}</div>
      </div>
    </div>
  )
}
